<template>
  <div>
    <common-table :limitHeight="true" :table-columns="tableColumns" :url="url" :operate="operate"
      :form-fields="formFields" :permission="permission" :buttons="buttons" :searchs="searchs"
      ref="table"></common-table>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";
import request from "@/utils/axios";

export default {
  name: 'OceanEngineImage',
  components: { CommonTable },
  data() {
    return {
      searchs: [/*{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }*/{
          name: 'advertiserId',
          placeholder: '广告主',
          type: 'select',
      selectUrl: '/oceanEngineAdvertiser/optionsByCondition',
          valueKey: 'advertiserId',
          selectData: [],
        }, {
          name: 'filename',
          placeholder: '商品ID',
          type: 'input'
        }],
      permission: {
        add: 'oceanEngineImage:add',
        update: 'oceanEngineImage:update',
        delete: 'oceanEngineImage:delete',
        deleteBatch: 'oceanEngineImage:deleteBatch'
      },
      url: {
        get: '/oceanEngineImage/listByCondition',
        add: '/oceanEngineImage/add',
        update: '/oceanEngineImage/update',
        delete: '/oceanEngineImage/delete',
        delete_batch: '/oceanEngineImage/deleteBatch',
        status: '/oceanEngineImage/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }/*, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
      }*/, {
        field: 'advertiserId',  // 字段名
        label: '广告主ID',  // 字段显示名称
        sort: false,  // 是否排序
      selectUrl: '/oceanEngineAdvertiser/optionsByCondition',
        valueKey: 'advertiserId',
        selectData: [],
        show: {
          type: 'select',
        },
      }, {
        field: 'aweMeId',  // 字段名
        label: '抖音号UID',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'analysisType',  // 字段名
        label: 'analysisType',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'filename',  // 字段名
        label: '素材文件名',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'height',  // 字段名
        label: '图片高度',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'imgId',  // 字段名
        label: '图片ID',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'imageMode',  // 字段名
        label: '素材类型',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'isAiCreate',  // 字段名
        label: '是否AI生成',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,
        selectData: [{
          id: 1,
          name: '是'
        }, {
          id: 0,
          name: '否'
        }],
      }, {
        field: 'materialId',  // 字段名
        label: '素材id',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'signature',  // 字段名
        label: '图片md5',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'size',  // 字段名
        label: '图片大小',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'source',  // 字段名
        label: '素材来源',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'tag',  // 字段名
        label: '素材标签',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'url',  // 字段名
        label: '图片预览地址',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
        img: true
      }, {
        field: 'width',  // 字段名
        label: '图片宽度',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'uploadTime',  // 字段名
        label: '素材上传时间',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
      }
      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: true
          },
          {
            field: 'agentId',  // 字段名
            label: 'agentId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入agentId',
            rules: [
              { required: true, message: 'agentId不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'advertiserId',  // 字段名
            label: 'advertiserId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入advertiserId',
            rules: [
              { required: true, message: 'advertiserId不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'aweMeId',  // 字段名
            label: 'aweMeId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入aweMeId',
            rules: [
              { required: true, message: 'aweMeId不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'analysisType',  // 字段名
            label: 'analysisType',  // 字段显示名称
            type: 'input',
            placeholder: '请输入analysisType',
            rules: [
              { required: true, message: 'analysisType不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'uploadTime',  // 字段名
            label: 'uploadTime',  // 字段显示名称
            type: 'input',
            placeholder: '请输入uploadTime',
            rules: [
              { required: true, message: 'uploadTime不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'filename',  // 字段名
            label: 'filename',  // 字段显示名称
            type: 'input',
            placeholder: '请输入filename',
            rules: [
              { required: true, message: 'filename不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'height',  // 字段名
            label: 'height',  // 字段显示名称
            type: 'input',
            placeholder: '请输入height',
            rules: [
              { required: true, message: 'height不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'imgId',  // 字段名
            label: 'imgId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入imgId',
            rules: [
              { required: true, message: 'imgId不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'imageMode',  // 字段名
            label: 'imageMode',  // 字段显示名称
            type: 'input',
            placeholder: '请输入imageMode',
            rules: [
              { required: true, message: 'imageMode不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'isAiCreate',  // 字段名
            label: 'isAiCreate',  // 字段显示名称
            type: 'input',
            placeholder: '请输入isAiCreate',
            rules: [
              { required: true, message: 'isAiCreate不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'materialId',  // 字段名
            label: 'materialId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入materialId',
            rules: [
              { required: true, message: 'materialId不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'signature',  // 字段名
            label: 'signature',  // 字段显示名称
            type: 'input',
            placeholder: '请输入signature',
            rules: [
              { required: true, message: 'signature不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'size',  // 字段名
            label: 'size',  // 字段显示名称
            type: 'input',
            placeholder: '请输入size',
            rules: [
              { required: true, message: 'size不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'source',  // 字段名
            label: 'source',  // 字段显示名称
            type: 'input',
            placeholder: '请输入source',
            rules: [
              { required: true, message: 'source不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'tag',  // 字段名
            label: 'tag',  // 字段显示名称
            type: 'input',
            placeholder: '请输入tag',
            rules: [
              { required: true, message: 'tag不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'url',  // 字段名
            label: 'url',  // 字段显示名称
            type: 'input',
            placeholder: '请输入url',
            rules: [
              { required: true, message: 'url不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'width',  // 字段名
            label: 'width',  // 字段显示名称
            type: 'input',
            placeholder: '请输入width',
            rules: [
              { required: true, message: 'width不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          },
        ]
      },
      operate: [],
      buttons: [{
        icon: 'el-icon-circle-check',
        type: 'success',
        text: '批量更新',
        permission: 'oceanEngineImage:updateInfo',
        click: () => {
          request.get({
            url: '/oceanEngineImage/getImage',
            success: (data) => {
              if (data.code == 0) {
                console.log(data, "123123")
              }
            }
          });
        }
      }]
    }
  }
}
</script>

<style scoped></style>
